import { jsx as _jsx } from "react/jsx-runtime";
import FeaturedSoftwareCoursesSubtitle from './FeaturedSoftwareCoursesSubtitle'; //@ts-expect-error Could not find declaration file for module

import useIsEnrolledInUserGuide from '../../../hooks/useIsEnrolledInUserGuide';
import SkeletonFeaturedSoftwareCoursesHeader from './SkeletonFeaturedSoftwareCoursesHeader'; //@ts-expect-error Could not find declaration file for module

import { useIsPaidAccount } from '../../../hooks/productsHooks';
import SectionHeading from '../../SectionHeading';
import { FormattedMessage } from '../../I18n';

const FeaturedSoftwareCoursesHeader = ({
  isLoadingData,
  selectedTab
}) => {
  const [isEnrolled, isEnrolledRequesting] = useIsEnrolledInUserGuide();
  const [isPaidAccount, isPaidAccountRequesting] = useIsPaidAccount();
  const isLoading = isLoadingData || isEnrolledRequesting || isPaidAccountRequesting;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(SectionHeading, {
      subText: isLoading ? /*#__PURE__*/_jsx(SkeletonFeaturedSoftwareCoursesHeader, {}) : /*#__PURE__*/_jsx(FeaturedSoftwareCoursesSubtitle, {
        isEnrolledOrPaid: isEnrolled || isPaidAccount,
        selectedTab: selectedTab
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.featuredSoftwareCourses.genericTitle"
      })
    })
  });
};

export default FeaturedSoftwareCoursesHeader;